import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { useSingleEffect } from 'react-haiku';

import Read from 'containers/Student/Courses/Read';
import Profile from 'containers/Student/Courses/Profile';

import { useAppStore } from 'store/useAppStore';

const Modules = () => {
	// Use app's store
	const [setSection, setTitle] = useAppStore(state => [state.setSection, state.setTitle]);

	// Set section on mount
	useSingleEffect(() => setSection('/courses'));

	// Set title on mount
	useSingleEffect(() => setTitle('Moduļi'));

	return (
		<Switch>
			<Route exact path="/courses">
				<Read />
			</Route>

			<Route path="/courses/:id(\d+)">
				<Profile />
			</Route>
		</Switch>
	);
};

export default Modules;